const categories = {
  '02be6c7e-9353-11ea-a6c8-06ef874d2a1c': {
    name: 'CNC Lathes - Integrated Turning and Milling Machines',
    parent: 'Turning'
  },
  '02be6e00-9353-11ea-a6c8-06ef874d2a1c': {
    name: 'Facing and Boring Lathes',
    parent: ''
  },
  '02be6f48-9353-11ea-a6c8-06ef874d2a1c': {
    name: 'Turning - Lathes Miscellaneous',
    parent: 'Turning'
  },
  '02be71a1-9353-11ea-a6c8-06ef874d2a1c': {
    name: 'Bar Feeders - CNC and Manual',
    parent: ''
  },
  '02be7297-9353-11ea-a6c8-06ef874d2a1c': {
    name: 'Production Lathes - Automatic - Single and Multispindle - Capstan and Turret',
    parent: ''
  },
  '02be737a-9353-11ea-a6c8-06ef874d2a1c': {
    name: 'Turning Vertical - CNC & Manual',
    parent: 'Turning'
  },
  '02be7456-9353-11ea-a6c8-06ef874d2a1c': {
    name: 'Threading and Screwing',
    parent: ''
  },
  '02be7531-9353-11ea-a6c8-06ef874d2a1c': {
    name: 'Centre Lathes - Manual - Straight and Gap Bed',
    parent: 'Turning'
  },
  '02be76e7-9353-11ea-a6c8-06ef874d2a1c': {
    name: 'Welding Machines - Arc - Mig - Mag - Tig etc',
    parent: ''
  },
  '02be77bf-9353-11ea-a6c8-06ef874d2a1c': {
    name: 'Welding Manipulators - Rotators - Seam etc',
    parent: ''
  },
  '02be789b-9353-11ea-a6c8-06ef874d2a1c': {
    name: 'Welding Equipment - Screens - Consumables etc',
    parent: ''
  },
  '02be7972-9353-11ea-a6c8-06ef874d2a1c': {
    name: 'Welding Miscellaneous',
    parent: ''
  },
  '02be7a4e-9353-11ea-a6c8-06ef874d2a1c': {
    name: 'Robotic Welding Cells - Welding Robots',
    parent: ''
  },
  '02be7c03-9353-11ea-a6c8-06ef874d2a1c': {
    name: 'Heading Machines',
    parent: ''
  },
  '02be7cda-9353-11ea-a6c8-06ef874d2a1c': {
    name: 'Thread Rolling - Thread Cutting, Screwing, Tapping',
    parent: ''
  },
  '02be7db3-9353-11ea-a6c8-06ef874d2a1c': {
    name: 'Wire Drawing - Spring Production',
    parent: ''
  },
  '02be7e87-9353-11ea-a6c8-06ef874d2a1c': {
    name: 'Fastener Miscellaneous',
    parent: ''
  },
  '02be8033-9353-11ea-a6c8-06ef874d2a1c': {
    name: 'Bead Blast - Shot Blast Machines',
    parent: ''
  },
  '02be810a-9353-11ea-a6c8-06ef874d2a1c': {
    name: 'Paint or Powder Coating',
    parent: ''
  },
  '02be81dc-9353-11ea-a6c8-06ef874d2a1c': {
    name: 'Surface Finishing Miscellaneous',
    parent: ''
  },
  '02be8385-9353-11ea-a6c8-06ef874d2a1c': {
    name: 'CNC Routing Machines',
    parent: ''
  },
  '02be845a-9353-11ea-a6c8-06ef874d2a1c': {
    name: 'Woodworking CNC - All Types',
    parent: 'Woodworking'
  },
  '02be8965-9353-11ea-a6c8-06ef874d2a1c': {
    name: 'Sawing',
    parent: ''
  },
  '02be8a80-9353-11ea-a6c8-06ef874d2a1c': {
    name: 'Planers',
    parent: ''
  },
  '02be8b58-9353-11ea-a6c8-06ef874d2a1c': {
    name: 'Sanding',
    parent: ''
  },
  '02be8c2f-9353-11ea-a6c8-06ef874d2a1c': {
    name: 'Lathes',
    parent: ''
  },
  '02be8d04-9353-11ea-a6c8-06ef874d2a1c': {
    name: 'Moulders',
    parent: ''
  },
  '02be8ddd-9353-11ea-a6c8-06ef874d2a1c': {
    name: 'Woodworking Miscellaneous',
    parent: 'Woodworking'
  },
  '02be9a7d-9353-11ea-a6c8-06ef874d2a1c': {
    name: 'Test Equipment - Electronic and Mechanical',
    parent: ''
  },
  '02be9b54-9353-11ea-a6c8-06ef874d2a1c': {
    name: 'Compressors and Associated Equipment',
    parent: 'General Workshop'
  },
  '02be9c29-9353-11ea-a6c8-06ef874d2a1c': {
    name: 'Ovens - Furnaces and Heat Treatment Equipment',
    parent: ''
  },
  '02be9cfe-9353-11ea-a6c8-06ef874d2a1c': {
    name: 'Storage Cabinets - Work Benches - Racking',
    parent: ''
  },
  '02be9dd4-9353-11ea-a6c8-06ef874d2a1c': {
    name: 'Workshop Miscellaneous',
    parent: 'General Workshop'
  },
  '02be9ea9-9353-11ea-a6c8-06ef874d2a1c': {
    name: 'Dust Extractors - Industrial Vacuum Cleaners',
    parent: 'General Workshop'
  },
  '02be9f7c-9353-11ea-a6c8-06ef874d2a1c': {
    name: 'Storage Tanks',
    parent: ''
  },
  '02bea053-9353-11ea-a6c8-06ef874d2a1c': {
    name: 'Storage Tanks - Pumps and Filters',
    parent: ''
  },
  '02bea1fa-9353-11ea-a6c8-06ef874d2a1c': {
    name: 'Horizontal Bandsaws',
    parent: ''
  },
  '02bea2cd-9353-11ea-a6c8-06ef874d2a1c': {
    name: 'Vertical Bandsaws',
    parent: ''
  },
  '02bea3a4-9353-11ea-a6c8-06ef874d2a1c': {
    name: 'Circular Blade Saws',
    parent: ''
  },
  '02bea47a-9353-11ea-a6c8-06ef874d2a1c': {
    name: 'Friction Blade Saws',
    parent: ''
  },
  '02bea552-9353-11ea-a6c8-06ef874d2a1c': {
    name: 'Power Hacksaws',
    parent: ''
  },
  '02bea625-9353-11ea-a6c8-06ef874d2a1c': {
    name: 'Sawing Miscellaneous',
    parent: ''
  },
  '02beae7f-9353-11ea-a6c8-06ef874d2a1c': {
    name: 'Food Processing Equipment',
    parent: ''
  },
  '02beaf51-9353-11ea-a6c8-06ef874d2a1c': {
    name: 'Food Packaging',
    parent: ''
  },
  '02beb024-9353-11ea-a6c8-06ef874d2a1c': {
    name: 'Food Equipment Miscellaneous',
    parent: ''
  },
  '02beb1cf-9353-11ea-a6c8-06ef874d2a1c': {
    name: 'Forging Hammers / Presses',
    parent: ''
  },
  '02beb310-9353-11ea-a6c8-06ef874d2a1c': {
    name: 'Forging Miscellaneous',
    parent: ''
  },
  '02beb4cc-9353-11ea-a6c8-06ef874d2a1c': {
    name: 'All',
    parent: ''
  },
  '02beb59f-9353-11ea-a6c8-06ef874d2a1c': {
    name: 'Slotting and Shaping Machines',
    parent: ''
  },
  '02beb673-9353-11ea-a6c8-06ef874d2a1c': {
    name: 'Broaching and Key Seating',
    parent: ''
  },
  '02beb81d-9353-11ea-a6c8-06ef874d2a1c': {
    name: 'Workshop Tooling Vices, Rotary Tables, Angle Plates, Dividing Heads',
    parent: ''
  },
  '02beb8f2-9353-11ea-a6c8-06ef874d2a1c': {
    name: 'Power Hand Tools Electric and Pneumatic',
    parent: ''
  },
  '02beb9c9-9353-11ea-a6c8-06ef874d2a1c': {
    name: 'Cutting Tools - Milling, Turning, Carbide, Drills, Reamers etc',
    parent: ''
  },
  '02bebaa1-9353-11ea-a6c8-06ef874d2a1c': {
    name: 'Tooling Miscellaneous',
    parent: ''
  },
  '02bebc4d-9353-11ea-a6c8-06ef874d2a1c': {
    name: 'Bed Mills',
    parent: ''
  },
  '02bebd25-9353-11ea-a6c8-06ef874d2a1c': {
    name: 'Routing and Engraving',
    parent: ''
  },
  '02bebdf8-9353-11ea-a6c8-06ef874d2a1c': {
    name: 'Vertical and Turret Milling - Manual',
    parent: ''
  },
  '02bebecd-9353-11ea-a6c8-06ef874d2a1c': {
    name: 'Milling Miscellaneous',
    parent: ''
  },
  '02bebfa1-9353-11ea-a6c8-06ef874d2a1c': {
    name: 'Production Mills',
    parent: ''
  },
  '02bec075-9353-11ea-a6c8-06ef874d2a1c': {
    name: 'CNC Milling - Machining Centres - Vertical and Horizontal',
    parent: 'Milling'
  },
  '02bec148-9353-11ea-a6c8-06ef874d2a1c': {
    name: 'CNC Horizontal Machining Centres',
    parent: ''
  },
  '02bec918-9353-11ea-a6c8-06ef874d2a1c': {
    name: 'Bed Milling - CNC and Manual',
    parent: ''
  },
  '02bec9ed-9353-11ea-a6c8-06ef874d2a1c': {
    name: 'Vertical Milling',
    parent: ''
  },
  '02becac5-9353-11ea-a6c8-06ef874d2a1c': {
    name: 'Horizontal and Universal Milling - Manual',
    parent: ''
  },
  '02becb9b-9353-11ea-a6c8-06ef874d2a1c': {
    name: 'Routing and Engraving - CNC and Manual',
    parent: 'Milling'
  },
  '02becdcc-9353-11ea-a6c8-06ef874d2a1c': {
    name: 'Horizontal Boring Machines - CNC and Manual',
    parent: 'Boring'
  },
  '02becea4-9353-11ea-a6c8-06ef874d2a1c': {
    name: 'Horizontal Boring Machines',
    parent: 'Boring'
  },
  '02becf7f-9353-11ea-a6c8-06ef874d2a1c': {
    name: 'Vertical Boring / Vertical Turret Lathes',
    parent: ''
  },
  '02bed059-9353-11ea-a6c8-06ef874d2a1c': {
    name: 'Vertical Boring / Vertical Turret Lathes - CNC and Manual',
    parent: ''
  },
  '02bed12b-9353-11ea-a6c8-06ef874d2a1c': {
    name: 'Boring Miscellaneous',
    parent: ''
  },
  '02bed202-9353-11ea-a6c8-06ef874d2a1c': {
    name: 'Jig Boring - CNC and Manual',
    parent: 'Boring'
  },
  '02bed3b7-9353-11ea-a6c8-06ef874d2a1c': {
    name: 'Drilling - Single and Multispindle - CNC and Manual',
    parent: ''
  },
  '02bed48e-9353-11ea-a6c8-06ef874d2a1c': {
    name: 'Drilling',
    parent: 'General Workshop'
  },
  '02bed578-9353-11ea-a6c8-06ef874d2a1c': {
    name: 'Deep Hole Drilling - Production Drilling',
    parent: ''
  },
  '02beda1e-9353-11ea-a6c8-06ef874d2a1c': {
    name: 'Deep Hole Drilling',
    parent: ''
  },
  '02bedaf8-9353-11ea-a6c8-06ef874d2a1c': {
    name: 'Drilling Miscellaneous',
    parent: ''
  },
  '02bedc2f-9353-11ea-a6c8-06ef874d2a1c': {
    name: 'Radial Drilling',
    parent: ''
  },
  '02beddeb-9353-11ea-a6c8-06ef874d2a1c': {
    name: 'Surface Grinders - CNC and Manual',
    parent: ''
  },
  '02bedec1-9353-11ea-a6c8-06ef874d2a1c': {
    name: 'Jig Grinding - CNC and Manual',
    parent: ''
  },
  '02bedf99-9353-11ea-a6c8-06ef874d2a1c': {
    name: 'Grinding Miscellaneous',
    parent: ''
  },
  '02bee070-9353-11ea-a6c8-06ef874d2a1c': {
    name: 'Rotary Table Surface Grinders',
    parent: ''
  },
  '02bee145-9353-11ea-a6c8-06ef874d2a1c': {
    name: 'Knife - Blade Grinders',
    parent: ''
  },
  '02bee21c-9353-11ea-a6c8-06ef874d2a1c': {
    name: 'Honing and Lapping',
    parent: ''
  },
  '02bee2f3-9353-11ea-a6c8-06ef874d2a1c': {
    name: 'Band Grinders - Band Facers - Belt Grinders - Linishers etc',
    parent: ''
  },
  '02bee7c4-9353-11ea-a6c8-06ef874d2a1c': {
    name: 'Hand Grinders - Double Ended - Fettling etc',
    parent: ''
  },
  '02bee8a0-9353-11ea-a6c8-06ef874d2a1c': {
    name: 'Creep Feed Surface Grinders',
    parent: ''
  },
  '02bee975-9353-11ea-a6c8-06ef874d2a1c': {
    name: 'Tool and Cutter Grinders - CNC and Manual',
    parent: ''
  },
  '02beea4a-9353-11ea-a6c8-06ef874d2a1c': {
    name: 'Cylindrical Grinders - CNC and Manual',
    parent: ''
  },
  '02beeb25-9353-11ea-a6c8-06ef874d2a1c': {
    name: 'Surface Grinders',
    parent: ''
  },
  '02beebf9-9353-11ea-a6c8-06ef874d2a1c': {
    name: 'CNC Tool and Cutter Grinders',
    parent: ''
  },
  '02beecd7-9353-11ea-a6c8-06ef874d2a1c': {
    name: 'CNC Cylindrical Grinders',
    parent: ''
  },
  '02bef177-9353-11ea-a6c8-06ef874d2a1c': {
    name: 'Internal Grinding - CNC and Manual',
    parent: ''
  },
  '02bef32c-9353-11ea-a6c8-06ef874d2a1c': {
    name: 'Guillotines / Shears - CNC and Manual',
    parent: 'Fabricating / Sheet Metal'
  },
  '02bef4d2-9353-11ea-a6c8-06ef874d2a1c': {
    name: 'Fabricating Miscellaneous',
    parent: ''
  },
  '02bef614-9353-11ea-a6c8-06ef874d2a1c': {
    name: 'Tube Bending - CNC and Manual',
    parent: 'Fabricating / Sheet Metal'
  },
  '02befb11-9353-11ea-a6c8-06ef874d2a1c': {
    name: 'CNC Tube Bending',
    parent: 'Fabricating / Sheet Metal'
  },
  '02befc4b-9353-11ea-a6c8-06ef874d2a1c': {
    name: 'Section Rolls',
    parent: 'Fabricating / Sheet Metal'
  },
  '02befd87-9353-11ea-a6c8-06ef874d2a1c': {
    name: 'Bending Rolls - CNC and Manual',
    parent: 'Fabricating / Sheet Metal'
  },
  '02bf0258-9353-11ea-a6c8-06ef874d2a1c': {
    name: 'Folders - Power and Hand',
    parent: ''
  },
  '02bf0391-9353-11ea-a6c8-06ef874d2a1c': {
    name: 'CNC Bending Rolls',
    parent: ''
  },
  '02bf08c6-9353-11ea-a6c8-06ef874d2a1c': {
    name: 'Profile Cutting (Gas or Plasma) Manual and CNC',
    parent: 'Fabricating / Sheet Metal'
  },
  '02bf0de0-9353-11ea-a6c8-06ef874d2a1c': {
    name: 'Laser and Water Cutting - CNC',
    parent: 'Fabricating / Sheet Metal'
  },
  '02bf12a0-9353-11ea-a6c8-06ef874d2a1c': {
    name: 'Punching Machines',
    parent: 'Fabricating / Sheet Metal'
  },
  '02bf1760-9353-11ea-a6c8-06ef874d2a1c': {
    name: 'Punching Machines - Manual and CNC',
    parent: ''
  },
  '02bf20e2-9353-11ea-a6c8-06ef874d2a1c': {
    name: 'Press Brakes',
    parent: 'Fabricating / Sheet Metal'
  },
  '02bf21cd-9353-11ea-a6c8-06ef874d2a1c': {
    name: 'Press Brakes and Folders - CNC and Manual',
    parent: 'Fabricating / Sheet Metal'
  },
  '02bf22a6-9353-11ea-a6c8-06ef874d2a1c': {
    name: 'Plasma Cutting - Manual',
    parent: ''
  },
  '02bf2459-9353-11ea-a6c8-06ef874d2a1c': {
    name: 'Die Sink - CNC and Manual',
    parent: 'Electric Discharge Machines '
  },
  '02bf252d-9353-11ea-a6c8-06ef874d2a1c': {
    name: 'Die Sink',
    parent: 'Electric Discharge Machines '
  },
  '02bf2602-9353-11ea-a6c8-06ef874d2a1c': {
    name: 'Wire Cut - CNC',
    parent: 'Electric Discharge Machines '
  },
  '02bf26d7-9353-11ea-a6c8-06ef874d2a1c': {
    name: 'EDM Miscellaneous - Hole Drill - Tooling - Consumables',
    parent: ''
  },
  '02bf27ac-9353-11ea-a6c8-06ef874d2a1c': {
    name: 'EDM Miscellaneous',
    parent: ''
  },
  '02bf295a-9353-11ea-a6c8-06ef874d2a1c': {
    name: 'Mechanical Presses',
    parent: 'Presses'
  },
  '02bf2a32-9353-11ea-a6c8-06ef874d2a1c': {
    name: 'Hydraulic Presses',
    parent: 'Presses'
  },
  '02bf2b07-9353-11ea-a6c8-06ef874d2a1c': {
    name: 'Press Equipment - Decoilers - Levellers etc',
    parent: 'Presses'
  },
  '02bf2bdd-9353-11ea-a6c8-06ef874d2a1c': {
    name: 'Hand Presses - Fly Presses',
    parent: 'Presses'
  },
  '02bf2cb3-9353-11ea-a6c8-06ef874d2a1c': {
    name: 'Presses',
    parent: 'Presses'
  },
  '02bf2e80-9353-11ea-a6c8-06ef874d2a1c': {
    name: 'Gear Miscellaneous',
    parent: ''
  },
  '02bf3003-9353-11ea-a6c8-06ef874d2a1c': {
    name: 'CNC Gear Cutting',
    parent: 'Gear Machines'
  },
  '02bf30dd-9353-11ea-a6c8-06ef874d2a1c': {
    name: 'Gear Cutting - CNC and Manual',
    parent: 'Gear Machines'
  },
  '02bf31ba-9353-11ea-a6c8-06ef874d2a1c': {
    name: 'Gear Grinding - CNC and Manual',
    parent: 'Gear Machines'
  },
  '02bf3291-9353-11ea-a6c8-06ef874d2a1c': {
    name: 'Gear Grinding',
    parent: 'Gear Machines'
  },
  '02bf3480-9353-11ea-a6c8-06ef874d2a1c': {
    name: 'Forklift Trucks',
    parent: 'General Workshop'
  },
  '02bf3555-9353-11ea-a6c8-06ef874d2a1c': {
    name: 'Motorised Trucks',
    parent: ''
  },
  '02bf3627-9353-11ea-a6c8-06ef874d2a1c': {
    name: 'Hand Trucks',
    parent: ''
  },
  '02bf36fc-9353-11ea-a6c8-06ef874d2a1c': {
    name: 'Cranes - Over Head and Jib',
    parent: 'General Workshop'
  },
  '02bf37d0-9353-11ea-a6c8-06ef874d2a1c': {
    name: 'Handling Miscellaneous',
    parent: ''
  },
  '02bf397b-9353-11ea-a6c8-06ef874d2a1c': {
    name: 'Plastic Injection Moulding Machines',
    parent: 'Plastics'
  },
  '02bf3a4d-9353-11ea-a6c8-06ef874d2a1c': {
    name: 'Plastic Machinery Miscellaneous',
    parent: ''
  },
  '02bf3b1f-9353-11ea-a6c8-06ef874d2a1c': {
    name: 'Extruded and Moulded Rubber',
    parent: 'Plastics'
  },
  '02bf3cca-9353-11ea-a6c8-06ef874d2a1c': {
    name: 'Reusable Material',
    parent: 'Metal Stock'
  },
  '02bf3e74-9353-11ea-a6c8-06ef874d2a1c': {
    name: 'Co Ordinate Measuring Machines',
    parent: 'Inspection'
  },
  '02bf3f4a-9353-11ea-a6c8-06ef874d2a1c': {
    name: 'Measuring Equipment - Micrometers - Verniers etc',
    parent: ''
  },
  '02bf4021-9353-11ea-a6c8-06ef874d2a1c': {
    name: 'Surface Tables - Surface Plates',
    parent: ''
  },
  '02bf40f7-9353-11ea-a6c8-06ef874d2a1c': {
    name: 'Inspection Miscellaneous',
    parent: 'General Workshop'
  },
  '02bf42a3-9353-11ea-a6c8-06ef874d2a1c': {
    name: 'Furnaces',
    parent: ''
  },
  '02bf4378-9353-11ea-a6c8-06ef874d2a1c': {
    name: 'Foundry Equipment and Miscellaneous',
    parent: 'Forging and Foundry'
  },
  '02bf4523-9353-11ea-a6c8-06ef874d2a1c': {
    name: 'Rolling Mills and Associated Equipment',
    parent: 'Rolling Mills / Roll Forming / Slitting Lines'
  },
  '02bf45f8-9353-11ea-a6c8-06ef874d2a1c': {
    name: 'Rolling Mills / Roll Forming / Slitting Lines',
    parent: 'Rolling Mills / Roll Forming / Slitting Lines'
  },
  '02bf5199-9353-11ea-a6c8-06ef874d2a1c': {
    name: 'Generators',
    parent: 'General Workshop'
  },
  '02bf526f-9353-11ea-a6c8-06ef874d2a1c': {
    name: 'Transformers',
    parent: ''
  },
  '02bf5346-9353-11ea-a6c8-06ef874d2a1c': {
    name: 'Switchgear',
    parent: ''
  },
  '02bf541c-9353-11ea-a6c8-06ef874d2a1c': {
    name: 'Testing Equipment',
    parent: ''
  },
  '02bf7d6c-9353-11ea-a6c8-06ef874d2a1c': {
    name: 'CNC Sliding Head Lathes',
    parent: ''
  },
  '02bf7eb4-9353-11ea-a6c8-06ef874d2a1c': {
    name: 'Woodworking Manual - All Types',
    parent: 'Woodworking'
  },
  '02bf8163-9353-11ea-a6c8-06ef874d2a1c': {
    name: 'Planing Machines',
    parent: ''
  },
  '02bf82dc-9353-11ea-a6c8-06ef874d2a1c': {
    name: 'Machine Tools Miscellaneous',
    parent: ''
  },
  '02bf8420-9353-11ea-a6c8-06ef874d2a1c': {
    name: 'Milling Spindle Tooling',
    parent: ''
  },
  '02bf8a65-9353-11ea-a6c8-06ef874d2a1c': {
    name: 'Robots - Automated Parts Handling',
    parent: ''
  },
  '02bf8ba6-9353-11ea-a6c8-06ef874d2a1c': {
    name: 'Packaging and Weighing',
    parent: ''
  },
  '02bf8ce3-9353-11ea-a6c8-06ef874d2a1c': {
    name: 'Stores - Parts - Stock - Electrical - Fasteners - Consumables etc',
    parent: ''
  },
  '02bf8e27-9353-11ea-a6c8-06ef874d2a1c': {
    name: 'Scrap Metal & WIP',
    parent: 'Metal Stock'
  },
  '02bf9707-9353-11ea-a6c8-06ef874d2a1c': {
    name: 'Electrical Miscellaneous',
    parent: ''
  },
  '02bf9848-9353-11ea-a6c8-06ef874d2a1c': {
    name: 'Chemical Process Plant',
    parent: ''
  },
  '02bf9c0b-9353-11ea-a6c8-06ef874d2a1c': {
    name: 'Pharmaceutical Processing',
    parent: ''
  },
  '02bf9d46-9353-11ea-a6c8-06ef874d2a1c': {
    name: 'Pharmaceutical Packaging',
    parent: ''
  },
  '02bf9e1b-9353-11ea-a6c8-06ef874d2a1c': {
    name: 'Pharmaceutical Miscellaneous',
    parent: ''
  },
  '02bf9ef1-9353-11ea-a6c8-06ef874d2a1c': {
    name: 'Slitting Lines',
    parent: ''
  },
  '02bf9fc8-9353-11ea-a6c8-06ef874d2a1c': {
    name: 'Building Consumables Processing',
    parent: ''
  },
  '02bfa177-9353-11ea-a6c8-06ef874d2a1c': {
    name: 'Motor Control Centre',
    parent: ''
  },
  '02c1e38a-9353-11ea-a6c8-06ef874d2a1c': {
    name: 'Electrical Motors',
    parent: ''
  },
  '02c1e85a-9353-11ea-a6c8-06ef874d2a1c': {
    name: 'Bearings',
    parent: ''
  },
  '02c2167f-9353-11ea-a6c8-06ef874d2a1c': {
    name: 'Slitting Lines Misc',
    parent: ''
  },
  '02c21b61-9353-11ea-a6c8-06ef874d2a1c': {
    name: 'CNC Routing Machines',
    parent: ''
  },
  '02c21c37-9353-11ea-a6c8-06ef874d2a1c': {
    name: 'CNC Polishing Machines',
    parent: ''
  },
  '02c21d0d-9353-11ea-a6c8-06ef874d2a1c': {
    name: 'Routing, Engraving and Polishing Misc.',
    parent: ''
  },
  '02c22a53-9353-11ea-a6c8-06ef874d2a1c': {
    name: 'Die Casting Machines',
    parent: ''
  },
  '02c22e76-9353-11ea-a6c8-06ef874d2a1c': {
    name: 'Straightening benches',
    parent: ''
  },
  '02c346c5-9353-11ea-a6c8-06ef874d2a1c': {
    name: 'Gensets',
    parent: ''
  },
  '02c34799-9353-11ea-a6c8-06ef874d2a1c': {
    name: 'Alternators',
    parent: ''
  },
  '02c35194-9353-11ea-a6c8-06ef874d2a1c': {
    name: 'Reactors',
    parent: ''
  },
  '02c455ec-9353-11ea-a6c8-06ef874d2a1c': {
    name: 'Recycling Plant and Equipment Miscellaneous',
    parent: ''
  },
  '02c5a02a-9353-11ea-a6c8-06ef874d2a1c': {
    name: 'Forklifts',
    parent: 'General Workshop'
  },
  '02c5a165-9353-11ea-a6c8-06ef874d2a1c': {
    name: 'EDM Cooling',
    parent: ''
  },
  '02c5a364-9353-11ea-a6c8-06ef874d2a1c': {
    name: 'Wire EDM',
    parent: ''
  },
  '02c5a561-9353-11ea-a6c8-06ef874d2a1c': {
    name: 'Sinker EDM',
    parent: ''
  },
  '02c5a6a4-9353-11ea-a6c8-06ef874d2a1c': {
    name: 'Hole Drilling EDM',
    parent: ''
  },
  '02c5a7db-9353-11ea-a6c8-06ef874d2a1c': {
    name: 'Electrial Test Cell',
    parent: ''
  },
  '02c5a916-9353-11ea-a6c8-06ef874d2a1c': {
    name: 'Pumps, Motors, Actuators',
    parent: ''
  },
  '02c5aabd-9353-11ea-a6c8-06ef874d2a1c': {
    name: 'Workbenches',
    parent: ''
  },
  '02c5abfd-9353-11ea-a6c8-06ef874d2a1c': {
    name: 'Fluorescent Penetrant - Magnetic Particle Inspection',
    parent: ''
  },
  '02c5ae77-9353-11ea-a6c8-06ef874d2a1c': {
    name: 'Airflow',
    parent: ''
  },
  '02c5af83-9353-11ea-a6c8-06ef874d2a1c': {
    name: 'Moment Weight Machines',
    parent: ''
  },
  '02c5b05d-9353-11ea-a6c8-06ef874d2a1c': {
    name: 'Vacuum Pressure Impregnation',
    parent: ''
  },
  '02c5b136-9353-11ea-a6c8-06ef874d2a1c': {
    name: 'Positioning / Rollers',
    parent: ''
  },
  '02c5b20d-9353-11ea-a6c8-06ef874d2a1c': {
    name: 'Brazing Machines',
    parent: ''
  },
  '02c5b2e2-9353-11ea-a6c8-06ef874d2a1c': {
    name: 'Electron Beam Welding',
    parent: ''
  },
  '02c5b577-9353-11ea-a6c8-06ef874d2a1c': {
    name: 'High Speed',
    parent: ''
  },
  '02c5b706-9353-11ea-a6c8-06ef874d2a1c': {
    name: 'Low Speed',
    parent: ''
  },
  '02c5b805-9353-11ea-a6c8-06ef874d2a1c': {
    name: 'Pedestals',
    parent: ''
  },
  '02c5b9b3-9353-11ea-a6c8-06ef874d2a1c': {
    name: 'Additive General',
    parent: '3D Printing Technologies'
  },
  '02c5ba89-9353-11ea-a6c8-06ef874d2a1c': {
    name: '3D Printers - Composites',
    parent: '3D Printing Technologies'
  },
  '02c5bb5d-9353-11ea-a6c8-06ef874d2a1c': {
    name: 'Stereolithography',
    parent: ''
  },
  '02c5bc31-9353-11ea-a6c8-06ef874d2a1c': {
    name: 'Material Jetting',
    parent: ''
  },
  '02c5be48-9353-11ea-a6c8-06ef874d2a1c': {
    name: 'Mobile Dust Collection',
    parent: ''
  },
  '02c5bf1f-9353-11ea-a6c8-06ef874d2a1c': {
    name: 'Centralized Dust Collection',
    parent: ''
  },
  '02c5c005-9353-11ea-a6c8-06ef874d2a1c': {
    name: 'Downdraft Tables',
    parent: ''
  },
  '02c5c0da-9353-11ea-a6c8-06ef874d2a1c': {
    name: 'Oil Mist Eliminators',
    parent: ''
  },
  '02c5c281-9353-11ea-a6c8-06ef874d2a1c': {
    name: 'Tape Winders',
    parent: ''
  },
  '02c5c354-9353-11ea-a6c8-06ef874d2a1c': {
    name: 'Coil Winders',
    parent: ''
  },
  '02c5c565-9353-11ea-a6c8-06ef874d2a1c': {
    name: 'Annealing',
    parent: ''
  },
  '02c5c638-9353-11ea-a6c8-06ef874d2a1c': {
    name: 'Burn-off',
    parent: ''
  },
  '02c5c70e-9353-11ea-a6c8-06ef874d2a1c': {
    name: 'Induction',
    parent: ''
  },
  '02c5c7e7-9353-11ea-a6c8-06ef874d2a1c': {
    name: 'Curing',
    parent: ''
  },
  '02c5c8ba-9353-11ea-a6c8-06ef874d2a1c': {
    name: 'Kiln',
    parent: ''
  },
  '02c5c990-9353-11ea-a6c8-06ef874d2a1c': {
    name: 'Autoclaves',
    parent: ''
  },
  '02c5cb45-9353-11ea-a6c8-06ef874d2a1c': {
    name: 'Air Conditioning',
    parent: ''
  },
  '02c5cc1d-9353-11ea-a6c8-06ef874d2a1c': {
    name: 'Refrigeration',
    parent: ''
  },
  '02c5ccf1-9353-11ea-a6c8-06ef874d2a1c': {
    name: 'Freezers',
    parent: ''
  },
  '02c5cdc7-9353-11ea-a6c8-06ef874d2a1c': {
    name: 'Coolant Chiller',
    parent: ''
  },
  '02c5cf98-9353-11ea-a6c8-06ef874d2a1c': {
    name: 'Steam Turbines',
    parent: ''
  },
  '02c5d06e-9353-11ea-a6c8-06ef874d2a1c': {
    name: 'Gas Turbines',
    parent: ''
  },
  '02c5d144-9353-11ea-a6c8-06ef874d2a1c': {
    name: 'Gear Boxes',
    parent: ''
  },
  '02c5d21c-9353-11ea-a6c8-06ef874d2a1c': {
    name: 'Natural Gas Compression Skids',
    parent: ''
  },
  '02c5d31a-9353-11ea-a6c8-06ef874d2a1c': {
    name: 'Foundry Equipment - Furnaces',
    parent: ''
  },
  '02c5d42a-9353-11ea-a6c8-06ef874d2a1c': {
    name: 'Powder / Fusion',
    parent: ''
  },
  '02c5d502-9353-11ea-a6c8-06ef874d2a1c': {
    name: 'Binder Jetting',
    parent: ''
  },
  '02c5d5d7-9353-11ea-a6c8-06ef874d2a1c': {
    name: 'Laser Melting',
    parent: ''
  },
  '02c5d6b8-9353-11ea-a6c8-06ef874d2a1c': {
    name: 'Air Lift Tables',
    parent: ''
  },
  '02c5d78b-9353-11ea-a6c8-06ef874d2a1c': {
    name: 'Material Storage Systems',
    parent: ''
  },
  '02c5d85f-9353-11ea-a6c8-06ef874d2a1c': {
    name: 'Stationary Racking',
    parent: ''
  },
  '02c5da0c-9353-11ea-a6c8-06ef874d2a1c': {
    name: 'Mobile Cranes',
    parent: 'General Workshop'
  },
  '02c5dae1-9353-11ea-a6c8-06ef874d2a1c': {
    name: 'Motorized Tractors',
    parent: ''
  },
  '02c5dbba-9353-11ea-a6c8-06ef874d2a1c': {
    name: 'Trailers',
    parent: ''
  },
  '02c5dc8d-9353-11ea-a6c8-06ef874d2a1c': {
    name: 'Automobiles',
    parent: ''
  },
  '02c5dd66-9353-11ea-a6c8-06ef874d2a1c': {
    name: 'Trailer-Mounted Containers (Conex)',
    parent: ''
  },
  '02c5de38-9353-11ea-a6c8-06ef874d2a1c': {
    name: 'Multi-Axle Trailer',
    parent: ''
  },
  '02c5df0c-9353-11ea-a6c8-06ef874d2a1c': {
    name: 'Remote Operated Trailer',
    parent: ''
  },
  '02c5dfe3-9353-11ea-a6c8-06ef874d2a1c': {
    name: 'Motorized-Wheel Trailer (Not Remote Operated)',
    parent: ''
  },
  'b8cde253-7f86-421d-849b-53fe22599f1b': {
    name: 'Cars motorcycles and vehicles',
    parent: 'Cars motorcycles and vehicles'
  },
  '0cce8ea5-66af-43a5-bab2-d0c8f84e6f2b': {
    name: 'Commercial Vehicles',
    parent: 'Cars motorcycles and vehicles'
  },
  '6b497fb1-1d1d-412d-8eb4-8cfa3cd71747': {
    name: 'Buildings and Storage Miscellaneous',
    parent: 'Construction'
  },
  '9b19c6dd-5ab1-44f0-90af-e8339da62559': {
    name: 'Commercial buildings',
    parent: 'Construction'
  },
  '0d05bdc1-a413-4b3a-ac84-2b89501cc80d': {
    name: 'IT and Office Machines',
    parent: 'Office'
  },
  '72cfa5cd-c72a-4918-a11e-49d25d562e0b': {
    name: 'Furniture',
    parent: 'Office'
  },
  '49d55074-3d24-4905-8f0a-0193bc83e924': {
    name: 'Electronic Miscellaneous',
    parent: 'Electronics'
  },
  '9dcb2608-f76e-4cce-9a3b-8c5c40d32fb1': {
    name: 'Fastener Machines',
    parent: 'Fastener Machines'
  },
  '0abd72c8-0e32-4324-a549-f40b06aec64c': {
    name: 'Balancing Equipment',
    parent: 'General Workshop'
  },
  '032c24ae-227f-4f4c-a1eb-6f0686b250e3': {
    name: 'Bead Blast - Shot Blast Machines',
    parent: 'General Workshop'
  },
  '21db694c-5853-4cf9-b226-38bada72b04b': {
    name: 'Broaching and Key Seating',
    parent: 'General Workshop'
  },
  'ba36b9eb-988a-4162-b80b-6682dfd069bf': {
    name: 'Chemical and Surface Treatment',
    parent: 'General Workshop'
  },
  '174fa1a5-e820-4468-8058-0dab30673dc3': {
    name: 'Cranes - Over Head, Jib and mobile cranes',
    parent: 'General Workshop'
  },
  '7e75f5c0-40ee-4e8f-b5bc-d2d3596ca8dc': {
    name: 'Drilling',
    parent: 'General Workshop'
  },
  'f8f27a6f-63fe-467e-8416-4e9a43959fba': {
    name: 'Forklift Trucks and Motorized Factory Vehilces',
    parent: 'General Workshop'
  },
  '7a4b3a92-1da4-45bf-be0d-56eb4e561349': {
    name: 'Generators',
    parent: 'General Workshop'
  },
  '3a704ac7-9e2d-4af1-9f8f-453954db1445': {
    name: 'Grinding',
    parent: 'Grinding'
  },
  'b917a53d-e22f-4d9c-95a6-58b66922d33f': {
    name: 'Inspection Equipment',
    parent: 'General Workshop'
  },
  '79124ec9-ddd4-4e0a-9a97-3d91618f6770': {
    name: 'Machine Vices, Rotary Tables, Angle Plates, Dividing Heads ',
    parent: 'General Workshop'
  },
  '1f019dc5-cbf0-4efd-9898-e93d77b48084': {
    name: 'Material Stock, WIP and Scrap',
    parent: ''
  },
  '39278841-8889-4bb0-81c3-b9e4013f3a57': {
    name: 'Ovens - Furnace - Heat Treatment - Autoclaves',
    parent: 'General Workshop'
  },
  '0b8bc5e0-3095-4442-be50-db7e283193aa': {
    name: 'Power hand Tools Electric and Pneumatic',
    parent: 'General Workshop'
  },
  '7412dfa5-406c-4515-aad8-70c36b2bae4d': {
    name: 'Pumps, Motors, Actuators ',
    parent: 'General Workshop'
  },
  'd96d1ff9-adf6-491f-84fc-720300beffd1': {
    name: 'Robots - Automated Parts Handling',
    parent: 'General Workshop'
  },
  'edd4fc3d-78e7-4f9a-bef1-c8c76b3c1af2': {
    name: 'Sawing',
    parent: 'General Workshop'
  },
  'ca1c4bcf-9d6f-41d8-94c7-a494d63f21c5': {
    name: 'Broaching, Slotting, Shaping and Planing Machines ',
    parent: 'General Workshop'
  },
  'c43d20c1-27b8-4f95-bc06-8db201fa8176': {
    name: 'Testing Equipment - Electronic and Mechanical',
    parent: 'General Workshop'
  },
  '2fff9098-b2e1-4a0b-8a72-d063cdd8814a': {
    name: 'Tooling',
    parent: 'General Workshop'
  },
  'd3ff5cd2-138a-47fb-ab59-a0ce4652a545': {
    name: 'Transformers',
    parent: 'General Workshop'
  },
  '2ec035c4-0f71-4290-b452-ace0eb9126b9': {
    name: 'Welding',
    parent: 'General Workshop'
  },
  'eb98656e-0642-4934-a006-a0af80f22181': {
    name: 'Manual Milling',
    parent: 'Milling'
  },
  '2179f962-aa71-490b-b821-728560497b91': {
    name: 'Printing and Packaging Machinery',
    parent: 'Printing and Packaging'
  },
  'fa944328-56bc-4868-a338-7a1b7a610492': {
    name: 'Laboratory Equipment',
    parent: 'Laboratory Equipment'
  },
  '383efd48-90c3-4473-9c1e-5fa9dc6db93c': {
    name: 'Trailers',
    parent: ''
  },
  '02be8f87-9353-11ea-a6c8-06ef874d2a1c': {
    name: 'Commercial Vehicles',
    parent: 'Cars motorcycles and vehicles'
  },
  '02be9059-9353-11ea-a6c8-06ef874d2a1c': {
    name: 'Cars',
    parent: 'Cars motorcycles and vehicles'
  },
  '02be9130-9353-11ea-a6c8-06ef874d2a1c': {
    name: 'Vehicles Miscellaneous',
    parent: 'Cars motorcycles and vehicles'
  },
  '02be9206-9353-11ea-a6c8-06ef874d2a1c': {
    name: 'Trucks',
    parent: 'Cars motorcycles and vehicles'
  },
  '02be92df-9353-11ea-a6c8-06ef874d2a1c': {
    name: 'Trailers',
    parent: ''
  },
  '02be93b4-9353-11ea-a6c8-06ef874d2a1c': {
    name: 'Commercial Vehicle Spares',
    parent: ''
  },
  '02bf479e-9353-11ea-a6c8-06ef874d2a1c': {
    name: 'Skiffs',
    parent: ''
  },
  '02bf486e-9353-11ea-a6c8-06ef874d2a1c': {
    name: 'Dinghies',
    parent: ''
  },
  '02bf4941-9353-11ea-a6c8-06ef874d2a1c': {
    name: 'Canoes',
    parent: ''
  },
  '02bf4a15-9353-11ea-a6c8-06ef874d2a1c': {
    name: 'Punts and Gondolas',
    parent: ''
  },
  '02bf4aeb-9353-11ea-a6c8-06ef874d2a1c': {
    name: 'Gigs, ships boats and pulling boats',
    parent: ''
  },
  '02bf4bc0-9353-11ea-a6c8-06ef874d2a1c': {
    name: 'Fantasy boats',
    parent: ''
  },
  '02bf4c93-9353-11ea-a6c8-06ef874d2a1c': {
    name: 'Boats Miscellaneous',
    parent: ''
  },
  '02bf4d67-9353-11ea-a6c8-06ef874d2a1c': {
    name: 'Trailers',
    parent: ''
  },
  '02c1b21b-9353-11ea-a6c8-06ef874d2a1c': {
    name: 'Motorized',
    parent: ''
  },
  '02c1b74c-9353-11ea-a6c8-06ef874d2a1c': {
    name: 'Non-motorized',
    parent: ''
  },
  '02c1b840-9353-11ea-a6c8-06ef874d2a1c': {
    name: 'Motorcycles',
    parent: ''
  },
  '02c1b9f6-9353-11ea-a6c8-06ef874d2a1c': {
    name: 'Parts and Accessories',
    parent: ''
  },
  '02c1bacd-9353-11ea-a6c8-06ef874d2a1c': {
    name: 'Powersports',
    parent: ''
  },
  '02c1bba0-9353-11ea-a6c8-06ef874d2a1c': {
    name: 'Camping',
    parent: ''
  },
  '02c21753-9353-11ea-a6c8-06ef874d2a1c': {
    name: 'Buses',
    parent: ''
  },
  '02c21828-9353-11ea-a6c8-06ef874d2a1c': {
    name: 'LDVs',
    parent: ''
  },
  '02c21952-9353-11ea-a6c8-06ef874d2a1c': {
    name: 'Tractors',
    parent: ''
  },
  '02c58dc1-9353-11ea-a6c8-06ef874d2a1c': {
    name: 'Locomotives',
    parent: ''
  },
  '02c58efc-9353-11ea-a6c8-06ef874d2a1c': {
    name: 'Miscellaneous Spares, Parts, Scrap Metal',
    parent: ''
  },
  '02c5918e-9353-11ea-a6c8-06ef874d2a1c': {
    name: 'Combine Harvesters',
    parent: ''
  },
  '02c59347-9353-11ea-a6c8-06ef874d2a1c': {
    name: 'Tractors',
    parent: ''
  },
  '02c59619-9353-11ea-a6c8-06ef874d2a1c': {
    name: 'Trailers',
    parent: ''
  },
  '02c59785-9353-11ea-a6c8-06ef874d2a1c': {
    name: 'Implements',
    parent: ''
  },
  '02c598c4-9353-11ea-a6c8-06ef874d2a1c': {
    name: 'Spares',
    parent: ''
  },
  '02bf4f11-9353-11ea-a6c8-06ef874d2a1c': {
    name: 'Winding Plants',
    parent: ''
  },
  '02bf75df-9353-11ea-a6c8-06ef874d2a1c': {
    name: 'Gas Engines',
    parent: ''
  },
  '02bf785b-9353-11ea-a6c8-06ef874d2a1c': {
    name: 'Miscellaneous',
    parent: ''
  },
  '02bf7c29-9353-11ea-a6c8-06ef874d2a1c': {
    name: 'Miscellaneous',
    parent: ''
  },
  '02bf95c8-9353-11ea-a6c8-06ef874d2a1c': {
    name: 'Winding Miscellaneous',
    parent: ''
  },
  '02bf9acc-9353-11ea-a6c8-06ef874d2a1c': {
    name: 'All',
    parent: ''
  },
  '02bfa38e-9353-11ea-a6c8-06ef874d2a1c': {
    name: 'Belt',
    parent: ''
  },
  '02bfa46b-9353-11ea-a6c8-06ef874d2a1c': {
    name: 'Bucket',
    parent: ''
  },
  '02bfa543-9353-11ea-a6c8-06ef874d2a1c': {
    name: 'Pneumatic',
    parent: ''
  },
  '02bfa61a-9353-11ea-a6c8-06ef874d2a1c': {
    name: 'Roller',
    parent: ''
  },
  '02bfa6f0-9353-11ea-a6c8-06ef874d2a1c': {
    name: 'Screw',
    parent: ''
  },
  '02bfa7c8-9353-11ea-a6c8-06ef874d2a1c': {
    name: 'Vibrating',
    parent: ''
  },
  '02bfa89b-9353-11ea-a6c8-06ef874d2a1c': {
    name: 'Screener',
    parent: ''
  },
  '02bfa9ce-9353-11ea-a6c8-06ef874d2a1c': {
    name: 'Classifiers',
    parent: ''
  },
  '02bfabc2-9353-11ea-a6c8-06ef874d2a1c': {
    name: 'Track',
    parent: ''
  },
  '02bfad33-9353-11ea-a6c8-06ef874d2a1c': {
    name: 'Wheeled',
    parent: ''
  },
  '02bfaee3-9353-11ea-a6c8-06ef874d2a1c': {
    name: 'All Types',
    parent: ''
  },
  '02bfb090-9353-11ea-a6c8-06ef874d2a1c': {
    name: 'All Types',
    parent: ''
  },
  '02bfb24a-9353-11ea-a6c8-06ef874d2a1c': {
    name: 'Self Propelled',
    parent: ''
  },
  '02bfb35d-9353-11ea-a6c8-06ef874d2a1c': {
    name: 'Tow',
    parent: ''
  },
  '02bfb512-9353-11ea-a6c8-06ef874d2a1c': {
    name: 'Rope',
    parent: ''
  },
  '02bfb5e5-9353-11ea-a6c8-06ef874d2a1c': {
    name: 'Hydraulic',
    parent: ''
  },
  '02bfb792-9353-11ea-a6c8-06ef874d2a1c': {
    name: 'All types',
    parent: ''
  },
  '02bfb93f-9353-11ea-a6c8-06ef874d2a1c': {
    name: 'All types',
    parent: ''
  },
  '02bfbaec-9353-11ea-a6c8-06ef874d2a1c': {
    name: 'All types',
    parent: ''
  },
  '02bfbca0-9353-11ea-a6c8-06ef874d2a1c': {
    name: 'All types',
    parent: ''
  },
  '02bfbe4b-9353-11ea-a6c8-06ef874d2a1c': {
    name: 'All types',
    parent: ''
  },
  '02bfbff9-9353-11ea-a6c8-06ef874d2a1c': {
    name: 'All types',
    parent: ''
  },
  '02bfc1a7-9353-11ea-a6c8-06ef874d2a1c': {
    name: 'All types',
    parent: ''
  },
  '02bfc356-9353-11ea-a6c8-06ef874d2a1c': {
    name: 'All types',
    parent: ''
  },
  '02c21eb8-9353-11ea-a6c8-06ef874d2a1c': {
    name: 'Stackers and Sorters',
    parent: ''
  },
  '02c21f8f-9353-11ea-a6c8-06ef874d2a1c': {
    name: 'Process Plants',
    parent: ''
  },
  '02c22061-9353-11ea-a6c8-06ef874d2a1c': {
    name: 'Underground Equipment',
    parent: ''
  },
  '02c22133-9353-11ea-a6c8-06ef874d2a1c': {
    name: 'Stores and Safety',
    parent: ''
  },
  '02bf55c9-9353-11ea-a6c8-06ef874d2a1c': {
    name: 'Corrugated Converting Machines',
    parent: ''
  },
  '02bf91ec-9353-11ea-a6c8-06ef874d2a1c': {
    name: 'Die Cutting',
    parent: ''
  },
  '02bf932e-9353-11ea-a6c8-06ef874d2a1c': {
    name: 'Packaging Miscellaneous',
    parent: 'Printing & Packaging'
  },
  '02bf948b-9353-11ea-a6c8-06ef874d2a1c': {
    name: 'Printing Miscellaneous',
    parent: 'Printing & Packaging'
  },
  '02bf5776-9353-11ea-a6c8-06ef874d2a1c': {
    name: 'Plumbing Materials',
    parent: ''
  },
  '02bf5989-9353-11ea-a6c8-06ef874d2a1c': {
    name: 'Building Materials',
    parent: ''
  },
  '02c07d8a-9353-11ea-a6c8-06ef874d2a1c': {
    name: 'Doors',
    parent: ''
  },
  '02c07e5b-9353-11ea-a6c8-06ef874d2a1c': {
    name: 'Windows',
    parent: ''
  },
  '02c07fff-9353-11ea-a6c8-06ef874d2a1c': {
    name: 'Lamps, Lighting and Ceiling Fans',
    parent: ''
  },
  '02be956b-9353-11ea-a6c8-06ef874d2a1c': {
    name: 'Furniture and Storage',
    parent: ''
  },
  '02be9720-9353-11ea-a6c8-06ef874d2a1c': {
    name: 'Computers - Printers',
    parent: ''
  },
  '02be97f3-9353-11ea-a6c8-06ef874d2a1c': {
    name: 'IT and Office Machines',
    parent: ''
  },
  '02be98c7-9353-11ea-a6c8-06ef874d2a1c': {
    name: 'Office Miscellaneous',
    parent: ''
  },
  '02bf5b38-9353-11ea-a6c8-06ef874d2a1c': {
    name: 'Bathroom Equipment',
    parent: ''
  },
  '02bf5ce6-9353-11ea-a6c8-06ef874d2a1c': {
    name: 'Kitchen Equipment',
    parent: ''
  },
  '02bf66a8-9353-11ea-a6c8-06ef874d2a1c': {
    name: 'Household Miscellaneous',
    parent: ''
  },
  '02bf677e-9353-11ea-a6c8-06ef874d2a1c': {
    name: 'Gardening Equipment',
    parent: ''
  },
  '02c163d9-9353-11ea-a6c8-06ef874d2a1c': {
    name: 'Home D&eacute;cor',
    parent: ''
  },
  '02c164c0-9353-11ea-a6c8-06ef874d2a1c': {
    name: 'Appliances',
    parent: ''
  },
  '02c165f4-9353-11ea-a6c8-06ef874d2a1c': {
    name: 'Kitchen, Dining and Barware',
    parent: ''
  },
  '02bf50c2-9353-11ea-a6c8-06ef874d2a1c': {
    name: 'Miscellaneous',
    parent: ''
  },
  '02bf6a02-9353-11ea-a6c8-06ef874d2a1c': {
    name: 'Screen Printers',
    parent: ''
  },
  '02bf6aed-9353-11ea-a6c8-06ef874d2a1c': {
    name: 'Dispensers',
    parent: ''
  },
  '02bf6bc2-9353-11ea-a6c8-06ef874d2a1c': {
    name: 'Chip Shooters',
    parent: ''
  },
  '02bf6c99-9353-11ea-a6c8-06ef874d2a1c': {
    name: 'Flexible Placers',
    parent: ''
  },
  '02bf6d6c-9353-11ea-a6c8-06ef874d2a1c': {
    name: 'Board Conveyors',
    parent: ''
  },
  '02bf6e3f-9353-11ea-a6c8-06ef874d2a1c': {
    name: 'SMT Feeders',
    parent: ''
  },
  '02bf6f1c-9353-11ea-a6c8-06ef874d2a1c': {
    name: 'Reflow Ovens',
    parent: ''
  },
  '02bf6ff0-9353-11ea-a6c8-06ef874d2a1c': {
    name: 'Inspection/X-ray',
    parent: ''
  },
  '02bf70c5-9353-11ea-a6c8-06ef874d2a1c': {
    name: 'Through Hole',
    parent: ''
  },
  '02bf71a2-9353-11ea-a6c8-06ef874d2a1c': {
    name: 'Board Cleaning',
    parent: ''
  },
  '02bf727a-9353-11ea-a6c8-06ef874d2a1c': {
    name: 'Spare Parts',
    parent: ''
  },
  '02bf734c-9353-11ea-a6c8-06ef874d2a1c': {
    name: 'Accessories',
    parent: ''
  },
  '02bf7427-9353-11ea-a6c8-06ef874d2a1c': {
    name: 'Wave Solder',
    parent: ''
  },
  '02bea7cf-9353-11ea-a6c8-06ef874d2a1c': {
    name: 'Portable Buildings and Containers',
    parent: ''
  },
  '02bea8a4-9353-11ea-a6c8-06ef874d2a1c': {
    name: 'Buildings and Storage Miscellaneous',
    parent: ''
  },
  '02bea983-9353-11ea-a6c8-06ef874d2a1c': {
    name: 'Building Materials - Consumables',
    parent: ''
  },
  '02beab2e-9353-11ea-a6c8-06ef874d2a1c': {
    name: 'Excavators',
    parent: ''
  },
  '02beac02-9353-11ea-a6c8-06ef874d2a1c': {
    name: 'Mobile Cranes',
    parent: 'General Workshop'
  },
  '02beacd6-9353-11ea-a6c8-06ef874d2a1c': {
    name: 'Construction Vehicles - All Types and Miscellaneous',
    parent: ''
  },
  '02bf6856-9353-11ea-a6c8-06ef874d2a1c': {
    name: 'Drilling Equipment / Rigs',
    parent: ''
  },
  '02bfa0a1-9353-11ea-a6c8-06ef874d2a1c': {
    name: 'Commercial buildings',
    parent: ''
  },
  '02c14801-9353-11ea-a6c8-06ef874d2a1c': {
    name: 'TLB Backhoe Loaders',
    parent: ''
  },
  '02c149e0-9353-11ea-a6c8-06ef874d2a1c': {
    name: 'Compactors and Rollers - Riding',
    parent: ''
  },
  '02c14b2c-9353-11ea-a6c8-06ef874d2a1c': {
    name: 'Crawler Dozers and Loaders',
    parent: ''
  },
  '02c14d3a-9353-11ea-a6c8-06ef874d2a1c': {
    name: 'Graders',
    parent: ''
  },
  '02c14fa4-9353-11ea-a6c8-06ef874d2a1c': {
    name: 'Lifts',
    parent: ''
  },
  '02c15921-9353-11ea-a6c8-06ef874d2a1c': {
    name: 'Pavers - Asphalt and Concrete',
    parent: ''
  },
  '02c15a88-9353-11ea-a6c8-06ef874d2a1c': {
    name: 'Scrapers',
    parent: ''
  },
  '02c15ca7-9353-11ea-a6c8-06ef874d2a1c': {
    name: 'Skid Steer Loaders',
    parent: ''
  },
  '02c15ec1-9353-11ea-a6c8-06ef874d2a1c': {
    name: 'Trenchers - Riding',
    parent: ''
  },
  '02c16047-9353-11ea-a6c8-06ef874d2a1c': {
    name: 'Wheel Loaders',
    parent: ''
  },
  '02c1624e-9353-11ea-a6c8-06ef874d2a1c': {
    name: 'Wood Chippers and Stump Grinders',
    parent: ''
  },
  '02c1dea2-9353-11ea-a6c8-06ef874d2a1c': {
    name: 'Construction Plant and Equipment Miscellaneous',
    parent: ''
  },
  '02c34445-9353-11ea-a6c8-06ef874d2a1c': {
    name: 'Articulated Dump Trucks',
    parent: ''
  },
  '02c3451b-9353-11ea-a6c8-06ef874d2a1c': {
    name: 'Telehandlers',
    parent: ''
  },
  '02c345f0-9353-11ea-a6c8-06ef874d2a1c': {
    name: 'Scissor and Boom Lifts',
    parent: ''
  },
  '02bf86a0-9353-11ea-a6c8-06ef874d2a1c': {
    name: 'Farming Miscellaneous',
    parent: ''
  },
  '02bf87e1-9353-11ea-a6c8-06ef874d2a1c': {
    name: 'Farm Implements and Equipment',
    parent: ''
  },
  '02bf8921-9353-11ea-a6c8-06ef874d2a1c': {
    name: 'Tractors',
    parent: ''
  },
  '02c11650-9353-11ea-a6c8-06ef874d2a1c': {
    name: 'Riding Mowers',
    parent: ''
  },
  '02c119f4-9353-11ea-a6c8-06ef874d2a1c': {
    name: 'Outdoor Living',
    parent: ''
  },
  '02c11cb1-9353-11ea-a6c8-06ef874d2a1c': {
    name: 'Gardening',
    parent: ''
  },
  '02bfcd66-9353-11ea-a6c8-06ef874d2a1c': {
    name: 'All types',
    parent: ''
  },
  '02bfcf18-9353-11ea-a6c8-06ef874d2a1c': {
    name: 'Package',
    parent: ''
  },
  '02bfcfee-9353-11ea-a6c8-06ef874d2a1c': {
    name: 'Direct',
    parent: ''
  },
  '02bfd0c2-9353-11ea-a6c8-06ef874d2a1c': {
    name: 'Misc',
    parent: ''
  },
  '02bfd26d-9353-11ea-a6c8-06ef874d2a1c': {
    name: 'All types',
    parent: ''
  },
  '02bfd45e-9353-11ea-a6c8-06ef874d2a1c': {
    name: 'All types',
    parent: ''
  },
  '02bfdfab-9353-11ea-a6c8-06ef874d2a1c': {
    name: 'Gas',
    parent: ''
  },
  '02bfe086-9353-11ea-a6c8-06ef874d2a1c': {
    name: 'Air',
    parent: ''
  },
  '02bfe15c-9353-11ea-a6c8-06ef874d2a1c': {
    name: 'Reciprocating',
    parent: ''
  },
  '02bfe232-9353-11ea-a6c8-06ef874d2a1c': {
    name: 'Screw',
    parent: ''
  },
  '02bfe306-9353-11ea-a6c8-06ef874d2a1c': {
    name: 'Lobe',
    parent: ''
  },
  '02bfe4b3-9353-11ea-a6c8-06ef874d2a1c': {
    name: 'All types',
    parent: ''
  },
  '02bfe65d-9353-11ea-a6c8-06ef874d2a1c': {
    name: 'Motor AC',
    parent: ''
  },
  '02bfe733-9353-11ea-a6c8-06ef874d2a1c': {
    name: 'Motor DC',
    parent: ''
  },
  '02bfe8da-9353-11ea-a6c8-06ef874d2a1c': {
    name: 'All types',
    parent: ''
  },
  '02bfea85-9353-11ea-a6c8-06ef874d2a1c': {
    name: 'All types',
    parent: ''
  },
  '02bfec31-9353-11ea-a6c8-06ef874d2a1c': {
    name: 'Condensing',
    parent: ''
  },
  '02bfed07-9353-11ea-a6c8-06ef874d2a1c': {
    name: 'Back Pressure',
    parent: ''
  },
  '02bfeeb0-9353-11ea-a6c8-06ef874d2a1c': {
    name: 'Shell and Tube',
    parent: ''
  },
  '02bfef85-9353-11ea-a6c8-06ef874d2a1c': {
    name: 'Plate',
    parent: ''
  },
  '02bff05e-9353-11ea-a6c8-06ef874d2a1c': {
    name: 'Fin and Jacket',
    parent: ''
  },
  '02bff135-9353-11ea-a6c8-06ef874d2a1c': {
    name: 'Fin Fan',
    parent: ''
  },
  '02bff2e1-9353-11ea-a6c8-06ef874d2a1c': {
    name: 'Analytical Apparatus',
    parent: ''
  },
  '02bff3ba-9353-11ea-a6c8-06ef874d2a1c': {
    name: 'Control Station',
    parent: ''
  },
  '02bff495-9353-11ea-a6c8-06ef874d2a1c': {
    name: 'Control System',
    parent: ''
  },
  '02bff56c-9353-11ea-a6c8-06ef874d2a1c': {
    name: 'Indicator and Probes',
    parent: ''
  },
  '02bff642-9353-11ea-a6c8-06ef874d2a1c': {
    name: 'Ammeter',
    parent: ''
  },
  '02bff8df-9353-11ea-a6c8-06ef874d2a1c': {
    name: 'Gas Chromatograph',
    parent: ''
  },
  '02bff9b8-9353-11ea-a6c8-06ef874d2a1c': {
    name: 'Infar red',
    parent: ''
  },
  '02bffa8e-9353-11ea-a6c8-06ef874d2a1c': {
    name: 'Meter',
    parent: ''
  },
  '02bffb68-9353-11ea-a6c8-06ef874d2a1c': {
    name: 'Misc',
    parent: ''
  },
  '02c000fc-9353-11ea-a6c8-06ef874d2a1c': {
    name: 'All types',
    parent: ''
  },
  '02c002ac-9353-11ea-a6c8-06ef874d2a1c': {
    name: 'Junior',
    parent: ''
  },
  '02c00381-9353-11ea-a6c8-06ef874d2a1c': {
    name: 'Senior',
    parent: ''
  },
  '02c0052f-9353-11ea-a6c8-06ef874d2a1c': {
    name: 'All types',
    parent: ''
  },
  '02c006df-9353-11ea-a6c8-06ef874d2a1c': {
    name: 'Engine, Diesel',
    parent: ''
  },
  '02c007b9-9353-11ea-a6c8-06ef874d2a1c': {
    name: 'Engine, Petrol',
    parent: ''
  },
  '02c0088d-9353-11ea-a6c8-06ef874d2a1c': {
    name: 'Motor, Air',
    parent: ''
  },
  '02c00964-9353-11ea-a6c8-06ef874d2a1c': {
    name: 'Motor, Hydraulic',
    parent: ''
  },
  '02c00a40-9353-11ea-a6c8-06ef874d2a1c': {
    name: 'Natural Gas',
    parent: ''
  },
  '02c00b16-9353-11ea-a6c8-06ef874d2a1c': {
    name: 'Motor, Nitrogen',
    parent: ''
  },
  '02c010c2-9353-11ea-a6c8-06ef874d2a1c': {
    name: 'Jet Engine',
    parent: ''
  },
  '02c01278-9353-11ea-a6c8-06ef874d2a1c': {
    name: 'Tubing',
    parent: ''
  },
  '02c01350-9353-11ea-a6c8-06ef874d2a1c': {
    name: 'Endless Tubing',
    parent: ''
  },
  '02c01428-9353-11ea-a6c8-06ef874d2a1c': {
    name: 'Casing',
    parent: ''
  },
  '02c014fc-9353-11ea-a6c8-06ef874d2a1c': {
    name: 'Drill',
    parent: ''
  },
  '02c015d1-9353-11ea-a6c8-06ef874d2a1c': {
    name: 'Flow Line',
    parent: ''
  },
  '02c01c8e-9353-11ea-a6c8-06ef874d2a1c': {
    name: 'Pipeline Misc',
    parent: ''
  },
  '02c01eff-9353-11ea-a6c8-06ef874d2a1c': {
    name: 'Centrifugal',
    parent: ''
  },
  '02c02037-9353-11ea-a6c8-06ef874d2a1c': {
    name: 'Diaphragm',
    parent: ''
  },
  '02c0216f-9353-11ea-a6c8-06ef874d2a1c': {
    name: 'Gear',
    parent: ''
  },
  '02c026ec-9353-11ea-a6c8-06ef874d2a1c': {
    name: 'In-Line',
    parent: ''
  },
  '02c0285e-9353-11ea-a6c8-06ef874d2a1c': {
    name: 'Plunger',
    parent: ''
  },
  '02c0299c-9353-11ea-a6c8-06ef874d2a1c': {
    name: 'Rotating Piston',
    parent: ''
  },
  '02c02ed6-9353-11ea-a6c8-06ef874d2a1c': {
    name: 'Screw',
    parent: ''
  },
  '02c03011-9353-11ea-a6c8-06ef874d2a1c': {
    name: 'Vacuum',
    parent: ''
  },
  '02c03531-9353-11ea-a6c8-06ef874d2a1c': {
    name: 'Worm',
    parent: ''
  },
  '02c03a3e-9353-11ea-a6c8-06ef874d2a1c': {
    name: 'Reciprocating',
    parent: ''
  },
  '02c0440e-9353-11ea-a6c8-06ef874d2a1c': {
    name: 'Deep well',
    parent: ''
  },
  '02c044f0-9353-11ea-a6c8-06ef874d2a1c': {
    name: 'Submersible',
    parent: ''
  },
  '02c046ff-9353-11ea-a6c8-06ef874d2a1c': {
    name: 'All types',
    parent: ''
  },
  '02c048ac-9353-11ea-a6c8-06ef874d2a1c': {
    name: 'All types',
    parent: ''
  },
  '02c04a5d-9353-11ea-a6c8-06ef874d2a1c': {
    name: 'All types',
    parent: ''
  },
  '02c04c09-9353-11ea-a6c8-06ef874d2a1c': {
    name: 'Misc',
    parent: ''
  },
  '02c04daf-9353-11ea-a6c8-06ef874d2a1c': {
    name: 'All types',
    parent: ''
  },
  '02c04f5e-9353-11ea-a6c8-06ef874d2a1c': {
    name: 'L Skidded',
    parent: ''
  },
  '02c0505e-9353-11ea-a6c8-06ef874d2a1c': {
    name: 'Free standing',
    parent: ''
  },
  '02c05166-9353-11ea-a6c8-06ef874d2a1c': {
    name: 'Silo',
    parent: ''
  },
  '02c05241-9353-11ea-a6c8-06ef874d2a1c': {
    name: 'Hopper',
    parent: ''
  },
  '02c053ec-9353-11ea-a6c8-06ef874d2a1c': {
    name: 'Vertical',
    parent: ''
  },
  '02c054be-9353-11ea-a6c8-06ef874d2a1c': {
    name: 'Horizontal',
    parent: ''
  },
  '02c0566b-9353-11ea-a6c8-06ef874d2a1c': {
    name: 'Angle',
    parent: ''
  },
  '02c05740-9353-11ea-a6c8-06ef874d2a1c': {
    name: 'Ball',
    parent: ''
  },
  '02c05813-9353-11ea-a6c8-06ef874d2a1c': {
    name: 'Butterfly',
    parent: ''
  },
  '02c058e6-9353-11ea-a6c8-06ef874d2a1c': {
    name: 'Gate',
    parent: ''
  },
  '02c059bb-9353-11ea-a6c8-06ef874d2a1c': {
    name: 'Globe',
    parent: ''
  },
  '02c05a90-9353-11ea-a6c8-06ef874d2a1c': {
    name: 'Motorized',
    parent: ''
  },
  '02c05b63-9353-11ea-a6c8-06ef874d2a1c': {
    name: 'Needle',
    parent: ''
  },
  '02c05c38-9353-11ea-a6c8-06ef874d2a1c': {
    name: 'Plug',
    parent: ''
  },
  '02c05d0a-9353-11ea-a6c8-06ef874d2a1c': {
    name: 'Rotary',
    parent: ''
  },
  '02c05dde-9353-11ea-a6c8-06ef874d2a1c': {
    name: 'Slide',
    parent: ''
  },
  '02c05eb3-9353-11ea-a6c8-06ef874d2a1c': {
    name: 'Switch',
    parent: ''
  },
  '02c05f86-9353-11ea-a6c8-06ef874d2a1c': {
    name: 'Wafer',
    parent: ''
  },
  '02c0605d-9353-11ea-a6c8-06ef874d2a1c': {
    name: 'Wellhead',
    parent: ''
  },
  '02c0612d-9353-11ea-a6c8-06ef874d2a1c': {
    name: 'Choke',
    parent: ''
  },
  '02c061ff-9353-11ea-a6c8-06ef874d2a1c': {
    name: 'Selector',
    parent: ''
  },
  '02c062d1-9353-11ea-a6c8-06ef874d2a1c': {
    name: 'Fitting',
    parent: ''
  },
  '02c063a5-9353-11ea-a6c8-06ef874d2a1c': {
    name: 'Pipe',
    parent: ''
  },
  '02c06478-9353-11ea-a6c8-06ef874d2a1c': {
    name: 'Check Valve',
    parent: ''
  },
  '02c0654d-9353-11ea-a6c8-06ef874d2a1c': {
    name: 'Misc',
    parent: ''
  },
  '02c066f5-9353-11ea-a6c8-06ef874d2a1c': {
    name: 'All types',
    parent: ''
  },
  '02c22f4a-9353-11ea-a6c8-06ef874d2a1c': {
    name: 'Metering',
    parent: ''
  },
  '02c3486b-9353-11ea-a6c8-06ef874d2a1c': {
    name: 'Engine Accessories',
    parent: ''
  },
  '02c1684c-9353-11ea-a6c8-06ef874d2a1c': {
    name: 'Exercise Equipment',
    parent: ''
  },
  '02c16922-9353-11ea-a6c8-06ef874d2a1c': {
    name: 'Exercise Supplies',
    parent: ''
  },
  '02c16b5e-9353-11ea-a6c8-06ef874d2a1c': {
    name: 'Fishing Tackle',
    parent: ''
  },
  '02c16c37-9353-11ea-a6c8-06ef874d2a1c': {
    name: 'Fishing Lures',
    parent: ''
  },
  '02c16d66-9353-11ea-a6c8-06ef874d2a1c': {
    name: 'Fishing Equipment',
    parent: ''
  },
  '02c16f12-9353-11ea-a6c8-06ef874d2a1c': {
    name: 'Archery and Bow Hunting',
    parent: ''
  },
  '02c1711a-9353-11ea-a6c8-06ef874d2a1c': {
    name: 'Knives and Swords',
    parent: ''
  },
  '02c1732f-9353-11ea-a6c8-06ef874d2a1c': {
    name: 'Taxidermy, Antlers and Mounts',
    parent: ''
  },
  '02c1880d-9353-11ea-a6c8-06ef874d2a1c': {
    name: 'Indoor Sports Gear',
    parent: ''
  },
  '02c18ac0-9353-11ea-a6c8-06ef874d2a1c': {
    name: 'Water Sports',
    parent: ''
  },
  '02c18ba5-9353-11ea-a6c8-06ef874d2a1c': {
    name: 'Winter Sports',
    parent: ''
  },
  '02c18c9353-11ea-a6c8-06ef874d2a1c': {
    name: 'Sports Miscellaneous',
    parent: ''
  }
}

module.exports = categories
